import { Home } from "@modules/home";
import "./style.scss";

new Home();
